import React from "react";

const CopyRights = () => {
  return (
    <div className="doc">
      <h3> Copyright and Data Accuracy Disclaimer</h3>

      <h3>Content Origin</h3>

      <p>
        Please be aware that all data and information presented in this
        application, including the UI and the database, are derived from the
        official Jelly Belly website. This project does not claim originality of
        the content and acknowledges that all information is borrowed from
        publicly available sources.
      </p>

      <h3>Disclaimer</h3>

      <p>
        While every effort has been made to ensure the accuracy of the
        information, there may be instances of errors, typos, or inaccuracies.
        Therefore, this resource should not be solely relied upon, especially
        for health-related decisions. I do not assume responsibility for the
        content's accuracy.
      </p>

      <h3>Consumer Advice</h3>

      <p>
        Before consuming any Jelly Belly products, it is strongly advised to
        consult the official Jelly Belly website or product packaging to verify
        ingredients, calorie content, and other nutritional information. This
        step is crucial for those with dietary restrictions or allergies.
      </p>
    </div>
  );
};

export default CopyRights;
